module.exports = __webpack_public_path__ + "static/media/empty_state_user.88b53271.svg";